import styled from '@emotion/styled';

import BaseButton from '@material-ui/core/Button';
import BaseDialogTitle from '@material-ui/core/DialogTitle';
import BaseDialogContent from '@material-ui/core/DialogContent';
import BaseDialogActions from '@material-ui/core/DialogActions';

import theme from '../../../../themes/default';

export const DialogTitle = styled(BaseDialogTitle)`
  padding-left: ${theme.spacing.xSmall};
  padding-top: ${theme.spacing.xSmall};
  padding-bottom: 0px;
`;

export const DialogContent = styled(BaseDialogContent)`
  && {
    padding: ${theme.spacing.xLarge} 0 0;
  }
`;

export const DialogActions = styled(BaseDialogActions)`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  margin: 0px;
  padding: 0 ${theme.spacing.xSmall} 14px 0;
`;

export const Button = styled(BaseButton)`
  text-transform: none;
  color: ${theme.color.designSystem.purple70};

  && {
    margin: 0 ${theme.spacing.xxSmall} 0 ${theme.spacing.medium};
  }
`;
